export const screenSizeManager = {
  initial: 'idle',
  invoke: { src: 'watchScreenMode' },
  states: {
    idle: {
      on: {
        ENVIRONMENT_SCREEN_SIZE_CHANGED: [
          {
            cond: 'isPromotionsPage',
            actions: [
              'saveCurrentScreenSize',
              'layout_changePageId',
              'layout_reload',
              'setBodyScrollable',
              'scrollTop',
            ],
          },
          {
            actions: [
              'saveCurrentScreenSize',
              'layout_reload',
              'setBodyScrollable',
              'scrollTop',
            ],
            target: 'off',
          },
        ],
      },
    },
    off: {
      invoke: {
        src: 'initializePersonalizedBannersWithContext',
        onDone: 'idle',
      },
    },
  },
};
